import { render, staticRenderFns } from "./Development.vue?vue&type=template&id=4ca6c3c8&scoped=true"
import script from "./Development.vue?vue&type=script&lang=js"
export * from "./Development.vue?vue&type=script&lang=js"
import style0 from "./Development.vue?vue&type=style&index=0&id=4ca6c3c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca6c3c8",
  null
  
)

export default component.exports